import { SchoolEvent } from 'models/event';

export function pageTVItems<T>(items: T[], cap: number, kind: string, title: string) {
  const pages = Math.ceil(items.length / cap);
  return Array.from({ length: pages }, (_, page) => ({
    id: `${kind}-${page}`, kind, title: pages > 1 ? `${title} · ${page + 1} of ${pages}` : title,
    items: items.slice(page * cap, (page + 1) * cap), offset: page * cap
  }));
}

export function individualTVEvents(events: SchoolEvent[], now: number) {
  const sorted = [...events].sort((a, b) => +new Date(a.startTime) - +new Date(b.startTime));
  const finished = (event: SchoolEvent) => event.status === 'FINISHED';
  const live = sorted.filter(event => !finished(event) && +new Date(event.startTime) <= now && (!event.endTime || +new Date(event.endTime) >= now));
  return {
    live,
    next: sorted.filter(event => !finished(event) && !live.includes(event)),
    done: sorted.filter(event => finished(event) && !event.showAsNotClosedOnPublicSite).reverse()
  };
}

export function rankedTVResults(event: SchoolEvent) {
  if (event.status !== 'FINISHED' || event.showAsNotClosedOnPublicSite) return [];
  const results = event.results || {} as SchoolEvent['results'];
  const teams = results.teamScore || [];
  const schools = results.schoolScore || [];
  const hasTeamResults = teams.some(row => row.richScore?.abbreviationResult || Number(row.richScore?.result ?? row.score ?? 0) !== 0);
  const source = event.sport?.isRelay || event.sport?.players === 'TEAM'
    ? hasTeamResults || !schools.length ? teams : schools
    : results.individualScore?.length ? results.individualScore : hasTeamResults ? teams : schools;
  const value = (row: any) => Number(row.richScore?.result ?? row.score ?? 0);
  const valid = (row: any) => Number.isFinite(value(row)) && value(row) !== 0;
  const rows = [...source].sort((a, b) => {
    if (valid(a) !== valid(b)) return valid(a) ? -1 : 1;
    return (String(event.sport?.scoring).startsWith('LESS_') ? value(a) - value(b) : value(b) - value(a)) || Number(b.richScore?.points || 0) - Number(a.richScore?.points || 0);
  });
  return rows.map((row, index) => ({ ...row, place: valid(row) ? rows.findIndex(other => valid(other) && value(other) === value(row) && other.richScore?.points === row.richScore?.points) + 1 : undefined }));
}
